import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const EvaluationFinaleBureautique = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="evaluation-finale-bureautique-lz054yr"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default EvaluationFinaleBureautique;